import React, { useState } from "react";
import './footer.css'

import black from '../img/black.png'

function Footer() {
    return (
        <div className="containerFooter">
            <p>Todos os direitos reservados</p>
            <p><a href="https://www.instagram.com/f.fsolutions/" target='blank'>@fsolutions</a></p>
        </div>
    )


}

export default Footer;